import React, { useMemo } from 'react';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { BadgeType, IActionItemProps } from '../../../../framework/components/bwj-listing/entities';
import { IStandardMaterial } from '../../../../entities-generated/common/standard-material';
import { IMaterialCallout } from '../../../../entities-generated/common/material-callout';

interface IMaterialListingProps {
  standardMaterial?: IStandardMaterial;
  material: IMaterialCallout | null;
  onAddMaterial: (material: IStandardMaterial) => void;
  onEditMaterial: (material: IMaterialCallout) => void;
  onRemoveMaterial: (material: IMaterialCallout) => void;
}

export const MaterialListing: React.FunctionComponent<IMaterialListingProps> = (props) => {
  const { standardMaterial, material, onRemoveMaterial } = props;
  const actions = useMemo(() => {
    const actions: IActionItemProps[] = [];
    !!material && actions.push({
      icon: 'Delete',
      onClick: () => onRemoveMaterial(material),
    });
    return actions;
  }, [material, onRemoveMaterial]);

  const heading = material?.description ?? standardMaterial?.description ?? 'Error';
  const icon = !!material ? 'CheckboxCompositeReversed' : 'Checkbox';
  const quantity = !!material ? `${material.quantity} qty.` : undefined;

   const onClick = () => {
    if(!!material) { 
      props.onEditMaterial(material);
    } else if(!!standardMaterial) {
      props.onAddMaterial(standardMaterial);
    }
   }

  return (
    <BwjListing
      actions={actions}
      heading={heading}
      badge={{
        type: BadgeType.Icon,
        content: icon,
      }}
      secondaryLine={quantity}
      onClick={onClick}
    />
  );
};
